import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '../ui.module';
import { ModalActionsComponent } from './modal-actions.component';
import { ModalContentComponent } from './modal-content.component';
import { ModalErrorComponent } from './modal-error.component';
import { ModalTitleComponent } from './modal-title.component';
import { ModalComponent } from './modal.component';

@NgModule({
  imports: [CommonModule, UiModule, RouterModule, ScrollingModule],
  declarations: [
    ModalComponent,
    ModalErrorComponent,
    ModalTitleComponent,
    ModalContentComponent,
    ModalActionsComponent,
  ],
  exports: [
    ModalComponent,
    ModalTitleComponent,
    ModalContentComponent,
    ModalActionsComponent,
  ],
})
export class ModalModule {}
